module.exports = __webpack_public_path__ + "img/janice-sung-lush.ae34d8c.jpg";